import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameSubForm, Schema as NameSchema } from '../subforms/Name';
import { ContactSubForm, Schema as ContactSchema } from '../subforms/Contact';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';
import { OtherInformationSubForm,Schema as OtherInformationSchema } from '../subforms/OtherInformation';

export const StadtwerkeBadKreuznachStandardSchema = (settings) => (
    Yup.object()
        .concat(NameSchema(settings))
        .concat(ContactSchema(settings))
        .concat(DocumentsSchema(settings))
        .concat(OtherInformationSchema(settings))
);

export const StadtwerkeBadKreuznachStandard = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameSubForm} colors={colors} settings={settings} />
            <Field component={ContactSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} settings={settings} />
        </>
    );
}